import React from 'react';
import styled from 'styled-components';
import Loader from '@features/ui/components/Loader';
import SerieHeader from '../components/SerieHeader';
import SerieContentWithSidePanel from '../components/SerieContentWithSidePanel';
import SerieSubscriptions from '../components/SerieSubscriptions';
import FormikContextProvider from '../components/FormikContextProvider';

const SerieSubscriptionsTemplate = ({ isLoading } : { isLoading: boolean }) => (
  isLoading ? <StyledLoader /> : (
    <>
      <SerieHeader />
      <SerieContentWithSidePanel>
        <FormikContextProvider><SerieSubscriptions /></FormikContextProvider>
      </SerieContentWithSidePanel>
    </>
  )
);

export default SerieSubscriptionsTemplate;

const StyledLoader = styled(Loader)`
  width: 100%;
`;
